module.exports = __webpack_public_path__ + "media/images/information/gift-06de87a0eb0abaade23d4804a27b3c43.svg";